import { useMemo } from 'react';

import { Box } from 'components/Box/Box';
import { Checkbox } from 'components/Checkbox/Checkbox';
import { getFieldQaId } from 'components/Form/Field/getFieldQaId';
import { LargeCheckbox } from 'components/LargeCheckbox/LargeCheckbox';

import type { CheckboxOption } from './CheckboxOption';
import { CheckboxContainer } from './Checkboxes.styled';

type Props = {
  id?: string;
  getValue: (optionName: string) => unknown;
  options: CheckboxOption[] | readonly CheckboxOption[];
  columns?: 1 | 2 | 3 | 4 | 5 | 6 | 7;
  hasError?: boolean;
  onChange: (checkboxName: string, value: boolean) => void;
  disabled?: boolean;
  large?: boolean;
  fullWidth?: boolean;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  getQaId?: (...args: any[]) => any;
  'data-qa-id': string;
  // TODO: Fix this the next time the file is edited.
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  onChangeByName?: (arg0: string) => (...args: any[]) => any;
};

export function Checkboxes({
  id,
  getValue,
  options,
  columns,
  hasError,
  onChange,
  disabled,
  large,
  fullWidth,
  getQaId,
  onChangeByName,
  ...props
}: Props) {
  const CheckboxComponent = useMemo(() => {
    if (large) {
      return LargeCheckbox;
    }
    return Checkbox;
  }, [large]);
  const getCheckboxQaId = getQaId || getFieldQaId;
  return (
    <CheckboxContainer
      $columns={columns}
      $large={large}
      $hasError={hasError}
      data-qa-id={props['data-qa-id']}
    >
      {options.map(({ label: checkboxLabel, name: checkboxName }, index) => (
        <Box
          key={checkboxName}
          pr={!columns && !large && index !== options.length - 1 ? '50px' : 0}
          p={large ? '6px' : undefined}
          width={columns && [1, 1, 1 / columns]}
        >
          <CheckboxComponent
            name={checkboxName}
            label={checkboxLabel}
            id={
              index === 0
                ? id || props['data-qa-id']
                : `${id || props['data-qa-id']}-${checkboxName}`
            }
            data-qa-id={`${props['data-qa-id']}-${getCheckboxQaId(
              checkboxName,
            )}`}
            onChange={(e) => {
              onChange(checkboxName, e);
              if (onChangeByName) {
                onChangeByName(checkboxName)(e);
              }
            }}
            checked={Boolean(getValue(checkboxName))}
            disabled={disabled}
            fullWidth={fullWidth}
          />
        </Box>
      ))}
    </CheckboxContainer>
  );
}
